import * as React from 'react';
import { SPP_PRODUCT_SHORT_DESCRIPTION } from '../../constants/DataTestIdAttributes';
import { classes } from '../../utils/Classes';
import styled from 'styled-components';
import { subtitle2Theme } from 'elc-typography';
import { ProductDescriptionTheme } from '../../../theme/default-theme';
import { ContentSpacing } from 'elc-base-theme';
import { observer } from 'mobx-react';

export interface IShortDescription extends IShortDescriptionOptions {
    overrides?: IShortDescriptionOverrides;
}

export interface IShortDescriptionOverrides {
    [key: string]: IShortDescriptionOptions;
}

export interface IShortDescriptionOptions {
    enabled: boolean;
    location?: string;
    charLimit?: number;
}

export interface IProductShortDescription {
    description: string;
}

const ProductShortDescriptionWrapper = styled.h2`
    ${subtitle2Theme}
    ${ProductDescriptionTheme}
    margin: ${ContentSpacing.space12} 0;
`;

export const ProductShortDescription = observer((props: IProductShortDescription) => {
    const { description } = props;
    const productShortDescriptionClassNames = classes('product-short-description-wrapper');

    return (
        <ProductShortDescriptionWrapper
            className={productShortDescriptionClassNames}
            dangerouslySetInnerHTML={{ __html: description }}
            data-test-id={SPP_PRODUCT_SHORT_DESCRIPTION}
        />
    );
});
